import { Button, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';

const ChartWrapper = ({
    children,
    title,
    link,
}) => {

    const navigate = useNavigate()

    return (
        <div className="bg-white p-4 rounded-xl shadow-sm relative">
            <div className="flex justify-between items-center mb-4">
                <p className="text-2xl font-bold">{title}</p>
                <Tooltip title={`View detailed ${title}`}>
                    <Link
                        type="link"
                        icon={<EyeOutlined />}
                        to={`/g-dashboard/${link}`}
                        className="flex items-center text-blue-600 hover:text-blue-800 font-medium"
                    >
                        View Details
                    </Link>
                </Tooltip>
            </div>
            {children}
        </div>
    );
};

export default ChartWrapper;